/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ChangePlan } from 'models/service'

/**********************************************************************************************************
 *    SLICE
 **********************************************************************************************************/
interface ServiceState {
    changePlanTemplate: 'configure' | 'confirm',
    changePlanValue: ChangePlan
}

const initialState: ServiceState = {
    changePlanTemplate: 'configure',
    changePlanValue: {
        billing_cycle_id: 0,
        product_id: 0,
        options: []
    }
}

export const serviceSlice = createSlice({
    name: 'service',
    initialState,
    reducers: {
        setChangePlanTemplate: (state, action: PayloadAction<'configure' | 'confirm'>) => {
            state.changePlanTemplate = action.payload
        },
        setChangePlanValue: (state, action: PayloadAction<ChangePlan>) => {
            state.changePlanValue = action.payload
        }
    }
})

export const { setChangePlanTemplate, setChangePlanValue } = serviceSlice.actions
export default serviceSlice.reducer
